import ApiService from '@/common/api.service'

const RESOURCE = 'actors'
const ActorService = {
  get (id, params) {
    return ApiService.get(RESOURCE, id, params)
  },
  getBySetting (id, settingId, params) {
    return ApiService.query(`${RESOURCE}/${id}/setting/${settingId}`, params)
  },
  getBySendMessage (id, params) {
    return ApiService.query(`${RESOURCE}/${id}/message`, params)
  },
  postMessage (id, params) {
    return ApiService.post(`${RESOURCE}/${id}/message`, params)
  },
  postMessageBySetting (id, settingId, params) {
    return ApiService.post(`${RESOURCE}/${id}/setting/${settingId}/message`, params)
  }
}
export default ActorService
